import { render, staticRenderFns } from "./fancyTableItem.vue?vue&type=template&id=2f919224&scoped=true&"
import script from "./fancyTableItem.vue?vue&type=script&lang=js&"
export * from "./fancyTableItem.vue?vue&type=script&lang=js&"
import style0 from "./fancyTableItem.vue?vue&type=style&index=0&id=2f919224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f919224",
  null
  
)

component.options.__file = "fancyTableItem.vue"
export default component.exports